import { CatalogueDef } from "./types";

export const CATALOGUE_REGISTRY: CatalogueDef[] = [
  {
    id: "propertyAmenities",
    title: "Property Amenities",
    filterKey: "marketingDefaultOrgConfig.property.amenities",
  },
  {
    id: "unitAmenities",
    title: "Unit Amenities",
    filterKey: "marketingDefaultOrgConfig.unit.amenities",
  },
  {
    id: "parkingAmenities",
    title: "Parking Types",
    filterKey: "marketingDefaultOrgConfig.property.parkingTypes",
  },
  {
    id: "pointOfInterestAmenities",
    title: "Points of Interest",
    filterKey: "marketingDefaultOrgConfig.property.pointsOfInterest",
  },
  {
    id: "viewingDaysConfig",
    title: "Viewing Days",
    filterKey: "marketingDefaultOrgConfig.viewingDaysConfig",
  },
  {
    id: "viewingTimeSlotsConfig",
    title: "Viewing Time Slots",
    filterKey: "marketingDefaultOrgConfig.viewingTimeSlotsConfig",
  },
  {
    id: "feedbackQuestionnaireConfig",
    title: "Feedback Questionnaire",
    filterKey: "marketingDefaultOrgConfig.feedbackQuestionnaireConfig",
  },
  {
    id: "marketingPublicListUrl",
    title: "Public List URL",
    filterKey: "marketingPublicListUrl",
  },
];

export const DEFAULT_CATALOGUE_ID = CATALOGUE_REGISTRY[0].id;
